module.exports = __webpack_public_path__ + "img/step_4-1.17ff462f.png";